import Header from '/business/shared/components/widgets/header/Header';

function ApplicationLayoutHeader() {
  return (
    <>
      <Header />
    </>
  );
}

export default ApplicationLayoutHeader;
